import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, MapPin, Phone, Mail, Send } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useToast } from "../hooks/use-toast";
import { nav, org } from "../mock";

const Footer = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({ title: "You're subscribed! 🌱", description: `Thanks for joining the ${org.shortName} community.` });
    setEmail("");
  };

  return (
    <footer className="bg-[hsl(195_30%_11%)] text-white/80 pt-16 pb-8 mt-0">
      <div className="container-prc">
        <div className="grid gap-12 lg:grid-cols-4 md:grid-cols-2">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src={org.logo} alt={org.name} className="h-12 w-12 rounded-xl object-contain bg-white" />
              <span className="font-display font-extrabold text-base text-white leading-tight">{org.shortName}<span className="block text-[11px] font-semibold uppercase tracking-wider text-accent">{org.tagline}</span></span>
            </Link>
            <p className="text-sm leading-relaxed text-white/70">{org.mission}</p>
            <div className="flex gap-3 mt-5">
              {[Facebook, Instagram, Twitter, Youtube].map((Icon) => (
                <a key={Icon.displayName || Icon.name} href="#" className="grid place-items-center h-9 w-9 rounded-full bg-white/10 hover:bg-accent transition-colors">
                  <Icon className="h-4 w-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-display font-bold mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              {nav.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-accent transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-display font-bold mb-4">Visit Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><MapPin className="h-5 w-5 text-accent shrink-0" />{org.address}</li>
              <li className="flex gap-3"><Phone className="h-5 w-5 text-accent shrink-0" />{org.phone}</li>
              <li className="flex gap-3"><Mail className="h-5 w-5 text-accent shrink-0" />{org.email}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-display font-bold mb-4">Stay in the loop</h4>
            <p className="text-sm text-white/70 mb-4">Program updates, events, and family tips — straight to your inbox.</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
              />
              <Button type="submit" className="btn-cta bg-accent hover:bg-accent/90 text-accent-foreground shrink-0">
                <Send className="h-4 w-4" />
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} {org.name}. All rights reserved. {org.ein}</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-accent">Privacy Policy</a>
            <a href="#" className="hover:text-accent">Terms</a>
            <a href="#" className="hover:text-accent">Financials</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
